import "antd/es/space/style";
import _Space from "antd/es/space";

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

import { jsx as _jsx } from "react/jsx-runtime";
import { useState, useEffect } from 'react';
import MediaWithPreview from '../media';
import { classifyType } from '../utils/tools';

var Documents = function Documents(_ref) {
  var _ref$docList = _ref.docList,
      docList = _ref$docList === void 0 ? [] : _ref$docList,
      _ref$docNames = _ref.docNames,
      docNames = _ref$docNames === void 0 ? [] : _ref$docNames,
      _ref$showAllPages = _ref.showAllPages,
      showAllPages = _ref$showAllPages === void 0 ? true : _ref$showAllPages,
      _ref$destroyOnClose = _ref.destroyOnClose,
      destroyOnClose = _ref$destroyOnClose === void 0 ? true : _ref$destroyOnClose;

  var _useState = useState(0),
      _useState2 = _slicedToArray(_useState, 2),
      current = _useState2[0],
      setCurrent = _useState2[1];

  var _useState3 = useState([]),
      _useState4 = _slicedToArray(_useState3, 2),
      list = _useState4[0],
      setList = _useState4[1];

  useEffect(function () {
    var typedList = docList.map( /*#__PURE__*/function () {
      var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(src) {
        var r, contentType, type;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.prev = 0;
                _context.next = 3;
                return fetch(src, {
                  cache: 'force-cache'
                });

              case 3:
                r = _context.sent;
                contentType = r.headers.get('content-type');
                type = classifyType(contentType);
                return _context.abrupt("return", {
                  type: type,
                  src: src
                });

              case 9:
                _context.prev = 9;
                _context.t0 = _context["catch"](0);
                return _context.abrupt("return", {
                  type: 'unknown',
                  src: src
                });

              case 12:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, null, [[0, 9]]);
      }));

      return function (_x) {
        return _ref2.apply(this, arguments);
      };
    }());
    var unmounted = false;
    Promise.all(typedList).then(function (r) {
      !unmounted && setList(r);
    });
    return function () {
      unmounted = true;
    };
  }, [docList]); // if document list changed, set current value is initial value

  useEffect(function () {
    setCurrent(0);
  }, [docList]);
  return _jsx(_Space, {
    size: [8, 8],
    wrap: true,
    children: list.map(function (_ref3, index) {
      var src = _ref3.src,
          type = _ref3.type;
      return _jsx("div", {
        style: {
          left: "".concat((index - current) * 100, "%")
        },
        children: _jsx(MediaWithPreview, {
          list: list,
          index: index,
          src: src,
          type: type,
          docNames: docNames,
          name: docNames[index],
          showAllPages: showAllPages,
          destroyOnClose: destroyOnClose
        })
      }, index);
    })
  });
};

export default Documents;